const ProviderUserType = Object.freeze({
	Unknown: 0,
	ClinicalNonRehab: 1,
	ClinicalRehabInClinic: 2,
	ClinicalRehabVirtual: 3,
	HealthplanProviderAnthemSISC: 4,
	HealthplanProviderCignaPhysicalMedicine: 5,
	HealthplanProviderOscar: 6,
	AnthemAdministrator: 7,
	FloridaBlueAdministrator: 8,
	CignaAdministrator: 9,
	ProvidenceAdministrator: 10,
	BannerHealthAdministrator: 11,
	BCBSAZAdministrator: 12,
	CentivoAdministrator: 13,
	HealthFirstAdministrator: 14,
	OhanaAdministrator: 15,
	OscarAdministrator: 16,
});

const ProviderUserTypeGroup = Object.freeze({
	Unknown: 'Unknown',
	Clinical: 'Clinical',
	Rehab: 'Rehab',
	HealthplanProvider: 'HealthplanProvider',
	HealthplanAdmin: 'HealthplanAdmin',
});

const getProviderUserTypeGroup = providerUserType => {
	switch (providerUserType) {
		case ProviderUserType.ClinicalNonRehab:
			return ProviderUserTypeGroup.Clinical;
		case ProviderUserType.ClinicalRehabInClinic:
		case ProviderUserType.ClinicalRehabVirtual:
			return ProviderUserTypeGroup.Rehab;
		case ProviderUserType.HealthplanProviderAnthemSISC:
		case ProviderUserType.HealthplanProviderCignaPhysicalMedicine:
		case ProviderUserType.HealthplanProviderOscar:
			return ProviderUserTypeGroup.HealthplanProvider;
		case ProviderUserType.AnthemAdministrator:
		case ProviderUserType.FloridaBlueAdministrator:
		case ProviderUserType.CignaAdministrator:
		case ProviderUserType.ProvidenceAdministrator:
		case ProviderUserType.BannerHealthAdministrator:
		case ProviderUserType.BCBSAZAdministrator:
		case ProviderUserType.CentivoAdministrator:
		case ProviderUserType.HealthFirstAdministrator:
		case ProviderUserType.OhanaAdministrator:
		case ProviderUserType.OscarAdministrator:
			return ProviderUserTypeGroup.HealthplanAdmin;
		default:
			return ProviderUserTypeGroup.Unknown;
	}
};

export { ProviderUserType, ProviderUserTypeGroup, getProviderUserTypeGroup };
